import { gql } from '@apollo/client';

export const DELETE_COMPONENTS_LIST = gql`
    mutation deleteComponentList( $input: DeleteComponentListInput! ) {
        result: deleteComponentList( input: $input ) {
            affectedRows
        }
    }
`;